<template>
    <div class="home">
        <div class="top-white-box"></div>

        <div class="black-friday-banner" v-if="settings.homepageBanner && settings.purimMode">
            <img :src="`/Assets/img/purim.jpg`">
        </div>
        <div class="black-friday-banner" v-else-if="settings.homepageBanner && settings.siteName != 'mommydeals'">
            <img :src="settings.homepageBanner">
        </div>

        <div class="top-gray-box" v-else>
            <h1>Latest Deals</h1>
        </div>

        <!--<GiveawayBox />-->
        <Deals :showJoinUs="true" :showPrice="true" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Deals from '@/components/Deals.vue'
//import GiveawayBox from '@/components/GiveawayBox.vue'
import settings, { SettingsClass } from '@/settings'

export default defineComponent({
    name: 'home',
    components: {
        Deals,
        //GiveawayBox
    },
    setup() {
        // No need for data() since we're not using any local state
        // The settings computed property is now just a constant since it's imported directly
        
        return {
            settings
        }
    }
})
</script>